var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * @module cercaliagl/layer/Marker
 */
import clustersDbscan from '@turf/clusters-dbscan';
import { featureCollection } from '@turf/helpers';
import bboxPolygon from '@turf/bbox-polygon';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import BaseLayer, { LayerType } from './Base';
import Bounds from '../Bounds';
import LonLat from '../LonLat';
import { isMobile } from '../util';
/**
 * @typedef {Object} Options
 * @property {string} id Layer id
 * @property {import("../Map").default} map Mapbox Map
 * @property {string} type Type
 * @property {function(this:Array.<Marker>): void} [onClusterClick] Callback function when mouse click cluster feature.
 * @property {function(this:Array.<Marker>): void} [onClusterMouseOver] Callback function when mouse over cluster feature.
 * @property {function(this:Array.<Marker>): void} [onClusterMouseOut] Callback function when mouse out cluster feature.
 * @property {Boolean} [clusteringEnabled] Enable/Disable clustering. Default `true`.
 * @property {number} [minTimeToDrag] Minimum time to start dragging a marker. Default `200`.
 */
/**
 * @typedef {Object} InternalMarkerLayerIds
 * @property {string} source
 * @property {string} symbol
 * @property {string} cluster
 * @property {string} clusterText
 */
/**
 * @typedef {Object} InternalMarkerLayerHeatmapIds
 * @property {string} heat
 * @property {string} point
 */
/**
 * @typedef {Object} StyleHeatLayer
 * @property {number} minzoom Min zoom
 * @property {number} maxzoom Max zoom.
 * @property {Object.<string, any>} paint Paint styles
 * @property {Object.<string, any>} layout Layout styles
 */
/**
 * The reason for these timeouts is to avoid when markers are added or removed.
 * When there are a lot of markers to add, it is necessary to avoid to call refresh geojson methods
 * because browser might crash.
 * @constant
 * @type {Object.<string, number>}
 */
var Timeout = {
    AddMarker: 100,
    RemoveMarker: 100,
};
/**
 * @constant
 * @type {Object.<string, any>}
 */
var ClusterStyles = {
    OPACITY: 1,
    STROKE_WIDTH: 2,
    STROKE_COLOR: '#ffffff',
    STROKE_OPACITY: 0.5,
    TEXT_FONT: 'Noto Sans Bold',
    TEXT_COLOR: '#000',
    TEXT_SIZE: 11, // 14
};
/**
 * @constant
 * @type {Object.<string, any>}
 */
var DefaultHeatStylesZones = {
    maxzoom: 15,
    paint: {
        'heatmap-intensity': [
            'interpolate', ['linear'], ['zoom'], 0, 0.1, 15, 1.5,
        ],
        'heatmap-color': [
            'interpolate', ['linear'],
            ['heatmap-density'], 0, 'rgba(0, 0, 255, 0)', 0.1, 'royalblue', 0.3, 'cyan', 0.5, 'lime', 0.7, 'yellow', 1, 'red',
        ],
        'heatmap-radius': [
            'interpolate', ['linear'], ['zoom'], 0, 1, 15, 14,
        ],
        'heatmap-opacity': [
            'interpolate', ['linear'], ['zoom'], 7, 0.8, 15, 0.3,
        ],
    },
};
/**
 * @constant
 * @type {Object.<string, any>}
 */
var DefaultHeatStylesPoints = {
    minzoom: 14,
    paint: {
        'circle-radius': [
            'interpolate', ['linear'], ['zoom'], 12, 3, 16, 6,
        ],
        'circle-color': 'rgba(0,0,0,0.4)',
        'circle-stroke-color': 'white',
        'circle-stroke-width': 1,
    },
};
/**
 * @classdesc
 * Layer for markers. This layer has the possibility to cluster markers with different values such radius and max zoom.
 * This class manages events and its callbacks methods.
 * All methods such as `addMarker`, `removeMarker` must be used from `cercaliagl.Map` methods. Don't use methods not published in this document page
 * to avoid possibles strange map behaviours.
 * @api
 */
var Marker = /** @class */ (function (_super) {
    __extends(Marker, _super);
    /**
     * @constructor
     * @param {Options} options
     */
    function Marker(options) {
        var _this = _super.call(this, {
            id: options.id,
            map: options.map,
            type: LayerType.SYMBOL,
        }) || this;
        /**
         * @private
         * @type {Object.<string, import("../Marker").default>}
         */
        _this.markers_ = {};
        /**
         * @private
         * @type {number}
         */
        _this.draggingFeatureId_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.mouseDownTimeStamp_ = 0;
        /**
         * @type {number}
         */
        _this.minTimeToDrag = options.minTimeToDrag ? options.minTimeToDrag : 200;
        /**
         * @private
         * @type {number}
         */
        _this.clusterMaxZoom_ = 16;
        /**
         * @private
         * @type {number}
         */
        _this.clusterRadius_ = 40;
        /**
         * @private
         * @type {InternalMarkerLayerIds}
         */
        _this.layerIds_ = /** @type {InternalMarkerLayerIds} */ ({
            source: _this.id_,
            symbol: "".concat(_this.id_, "_symbol"),
            cluster: "".concat(_this.id_, "_cluster"),
            clusterText: "".concat(_this.id_, "_cluster_text"),
        });
        /**
         * @private
         * @type {InternalMarkerLayerHeatmapIds}
         */
        _this.layerHeatIds_ = /** @type {InternalMarkerLayerHeatmapIds} */ ({
            heat: "".concat(_this.id_, "_heat"),
            point: "".concat(_this.id_, "_point"),
        });
        /**
         * @private
         * @type {boolean}
         */
        _this.clusteringEnabled_ = false;
        /**
         * @private
         * @type {boolean}
         */
        _this.heatEnabled_ = false;
        /**
         * @private
         * @type {GeoJSON}
         */
        _this.clusterMouseOvered_ = null;
        /**
         * @type {function(this:Array.<Marker>) : void|null}
         */
        _this.onClusterClick = options.onClusterClick ? options.onClusterClick : null;
        /**
         * @type {function(this:Array.<Marker>) : void|null}
         */
        _this.onClusterMouseOver = options.onClusterMouseOver ? options.onClusterMouseOver : null;
        /**
         * @type {function(this:Array.<Marker>) : void|null}
         */
        _this.onClusterMouseOut = options.onClusterMouseOut ? options.onClusterMouseOut : null;
        /**
         * @type {boolean|null}
         */
        _this.clusteringEnabled_ = options.clusteringEnabled ? options.clusteringEnabled : false;
        /**
         * @private
         * @type {number}
         */
        _this.layerOpacityFactor_ = options.layerOpacityFactor !== undefined ? options.layerOpacityFactor : 1;
        return _this;
    }
    /**
     * Initialize layers when added to map
     */
    Marker.prototype.initialize = function () {
        this.handleClick_ = this.handleClick_.bind(this);
        this.handleClickCluster_ = this.handleClickCluster_.bind(this);
        this.handleDoubleClick_ = this.handleDoubleClick_.bind(this);
        this.handleMouseMove_ = this.handleMouseMove_.bind(this);
        this.handleMouseEnter_ = this.handleMouseEnter_.bind(this);
        this.handleMouseLeave_ = this.handleMouseLeave_.bind(this);
        this.handleMouseDown_ = this.handleMouseDown_.bind(this);
        this.handleTouchStart_ = this.handleTouchStart_.bind(this);
        this.initializeLayers_();
    };
    /**
     * @private
     * @param {Object} layerParams
     */
    Marker.prototype.initializeLayers_ = function () {
        if (!this.clusteringEnabled_) {
            this.initializeSymbolNoClusteredLayer_();
        }
        else {
            this.initializeSymbolClusteredLayers_();
        }
        this.initializeEventsListeners_();
        this.source_ = this.map_.getSource(this.id_);
    };
    /**
     * Enable clustering. Clustering agroup markers in circle features showing total features clustered over this circular feature.
     * Callback events for cluster feature events is possible using {@link module:cercaliagl/Map~Map#enableClustering} method
     * @param {number} [maxZoom] Max zoom. Default `16`
     * @param {number} [clusterRadius] Radius in pixels for every cluster. Default `40`.
     * @api
     */
    Marker.prototype.enableClustering = function (maxZoom, clusterRadius) {
        if (maxZoom === void 0) { maxZoom = this.clusterMaxZoom_; }
        if (clusterRadius === void 0) { clusterRadius = this.clusterRadius_; }
        this.clusterRadius_ = clusterRadius;
        this.clusterMaxZoom_ = maxZoom;
        this.removeLayers();
        this.clusteringEnabled_ = true;
        this.initializeLayers_();
    };
    /**
     * Disable clustering markers.
     * @api
     */
    Marker.prototype.disableClustering = function () {
        if (this.clusteringEnabled_) {
            this.removeLayers();
            this.clusteringEnabled_ = false;
            this.initializeLayers_();
        }
    };
    /**
     * @private
     */
    Marker.prototype.initializeSymbolNoClusteredLayer_ = function () {
        this.map_.addSource(this.layerIds_.source, {
            type: 'geojson',
            data: this.geojson_,
            buffer: 0,
        });
        this.addDefaultSymbolLayer_();
    };
    /**
     * @private
     * @param {number} maxZoom
     * @param {number} clusteRadius
     */
    Marker.prototype.initializeSymbolClusteredLayers_ = function () {
        this.map_.addSource(this.layerIds_.source, {
            type: 'geojson',
            data: this.geojson_,
            cluster: true,
            clusterMaxZoom: this.clusterMaxZoom_,
            clusterRadius: this.clusterRadius_, // Radius of each cluster when clustering points (defaults to 50)
        });
        this.addLayer({
            id: this.layerIds_.cluster,
            source: this.layerIds_.source,
            type: 'circle',
            filter: ['has', 'point_count'],
            paint: {
                'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
                'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40],
                'circle-opacity': ['*', ClusterStyles.OPACITY, this.layerOpacityFactor_],
                'circle-stroke-width': ClusterStyles.STROKE_WIDTH,
                'circle-stroke-color': ClusterStyles.STROKE_COLOR,
                'circle-stroke-opacity': ['*', ClusterStyles.STROKE_OPACITY, this.layerOpacityFactor_],
            },
        });
        this.addLayer({
            id: this.layerIds_.clusterText,
            source: this.layerIds_.source,
            type: 'symbol',
            filter: ['has', 'point_count'],
            layout: {
                'text-field': '{point_count}',
                'text-font': [ClusterStyles.TEXT_FONT],
                'text-size': ClusterStyles.TEXT_SIZE,
            },
            paint: {
                'text-color': ClusterStyles.TEXT_COLOR,
                'text-opacity': this.layerOpacityFactor_,
            },
        });
        this.addDefaultSymbolLayer_();
    };
    /**
     * @private
     */
    Marker.prototype.addDefaultSymbolLayer_ = function () {
        this.addLayer({
            id: this.layerIds_.symbol,
            source: this.layerIds_.source,
            cluster: false,
            type: 'symbol',
            filter: ['all',
                ['==', 'visible', true],
            ],
            paint: {
                'text-halo-color': ['get', 'strokeColor'],
                'text-halo-width': ['get', 'strokeWidth'],
                'text-color': ['get', 'textColor'],
                'icon-opacity': ['*', ['get', 'iconOpacity'], this.layerOpacityFactor_],
                'text-opacity': ['*', ['get', 'textOpacity'], this.layerOpacityFactor_],
            },
            layout: {
                'icon-image': '{icon}',
                'icon-anchor': ['get', 'anchor'],
                'icon-offset': ['get', 'offset'],
                'icon-size': ['get', 'icon-size'],
                'icon-allow-overlap': true,
                'icon-rotate': ['get', 'rotation'],
                'text-font': ['Open Sans Bold'],
                'text-anchor': ['get', 'textAnchor'],
                'text-offset': ['get', 'textOffset'],
                'text-size': ['get', 'textSize'],
                'text-field': ['get', 'textField'],
                'text-justify': ['get', 'textJustify'],
                'text-allow-overlap': true,
                'text-rotate': ['get', 'textRotation'],
                'symbol-sort-key': ['get', 'zIndex'],
            },
        });
    };
    /**
     * Remove internal mapboxgl layers.
     * @override
     */
    Marker.prototype.removeLayers = function () {
        this.removeEventsListeners_();
        _super.prototype.removeLayers.call(this);
    };
    /**
     * @private
     */
    Marker.prototype.initializeEventsListeners_ = function () {
        this.map_.on('click', this.layerIds_.symbol, this.handleClick_);
        this.map_.on('dblclick', this.layerIds_.symbol, this.handleDoubleClick_);
        this.map_.on('mousemove', this.layerIds_.symbol, this.handleMouseMove_);
        this.map_.on('mouseenter', this.layerIds_.symbol, this.handleMouseEnter_);
        this.map_.on('mouseleave', this.layerIds_.symbol, this.handleMouseLeave_);
        this.map_.on('mousedown', this.layerIds_.symbol, this.handleMouseDown_);
        this.map_.on('touchstart', this.layerIds_.symbol, this.handleTouchStart_);
        if (this.clusteringEnabled_) {
            this.map_.on('click', this.layerIds_.cluster, this.handleClickCluster_);
            this.map_.on('mousemove', this.layerIds_.cluster, this.handleMouseMove_);
            this.map_.on('mouseleave', this.layerIds_.cluster, this.handleMouseLeave_);
            this.map_.on('mouseenter', this.layerIds_.cluster, this.handleMouseEnter_);
        }
    };
    /**
     * @private
     */
    Marker.prototype.removeEventsListeners_ = function () {
        this.map_.off('click', this.layerIds_.symbol, this.handleClick_);
        this.map_.off('dblclick', this.layerIds_.symbol, this.handleDoubleClick_);
        this.map_.off('mousemove', this.layerIds_.symbol, this.handleMouseMove_);
        this.map_.off('mouseenter', this.layerIds_.symbol, this.handleMouseEnter_);
        this.map_.off('mouseleave', this.layerIds_.symbol, this.handleMouseLeave_);
        this.map_.off('mousedown', this.layerIds_.symbol, this.handleMouseDown_);
        this.map_.off('touchstart', this.layerIds_.symbol, this.handleTouchStart_);
        // Cluster
        this.map_.off('click', this.layerIds_.cluster, this.handleClickCluster_);
        this.map_.off('mousemove', this.layerIds_.cluster, this.handleMouseMove_);
        this.map_.off('mouseleave', this.layerIds_.cluster, this.handleMouseLeave_);
        this.map_.off('mouseenter', this.layerIds_.cluster, this.handleMouseEnter_);
    };
    /**
     * @private
     * @param {Object} feature GeoJSON feature
     * @param {Function} callbackFn Callback function. Receives all markers objects
     */
    Marker.prototype.markersInCluster_ = function (feature, callbackFn) {
        var _this = this;
        var clusterId = feature.properties.cluster_id;
        var pointCount = feature.properties.point_count;
        var markers = [];
        this.source_.getClusterLeaves(clusterId, pointCount, 0, function (error, features) {
            features.forEach(function (featureAct) {
                markers.push(_this.markers_[featureAct.properties.id]);
            });
            if (callbackFn) {
                callbackFn(markers);
            }
        });
    };
    /**
     * @private
     * @param {Event} e Event
     */
    Marker.prototype.handleClick_ = function (e) {
        var _this = this;
        if (e.originalEvent.cancelBubble) {
            return;
        }
        e.preventDefault();
        var multipleFeaturesInPixel = this.cercaliaMap_.getMultipleFeaturesInPixel();
        var markers = this.getMarkersFromEvent_(e);
        if (multipleFeaturesInPixel) {
            markers.forEach(function (marker, i) {
                if (!e.features[i].properties.cluster) {
                    _this.markerClickOrPopup(e, marker);
                }
            });
        }
        else {
            var featuresAtPoint = this.map_.queryRenderedFeatures(e.point, { layers: this.cercaliaMap_.getLayerManager().getFeaturesLayersIds() });
            var featureWithMaxZIndex = this.getMapboxFeatureWithMaxZindex_(featuresAtPoint);
            if (featureWithMaxZIndex.layer.type !== 'symbol') {
                // There's a marker above the feature
                return;
            }
            this.markerClickOrPopup(e, this.markers_[featureWithMaxZIndex.properties.id]);
            e.originalEvent.cancelBubble = true; // workaraound to avoid multiple click events of markers of different layers
        }
    };
    /**
     * @private
     * @param {Event} e Event
     * @param {Marker[]} markers Event
     */
    // eslint-disable-next-line class-methods-use-this
    Marker.prototype.clickOnlyAboveMarker = function (e, markers) {
        if (markers && markers.length > 0) {
            var markerWithoutClusterAndMaxZIndex = markers.reduce(function (prev, current, currentIndex) { return (prev.getZIndex() > current.getZIndex() && !e.features[currentIndex].properties.cluster ? prev : current); });
            if (markerWithoutClusterAndMaxZIndex) {
                this.markerClickOrPopup(e, markerWithoutClusterAndMaxZIndex);
            }
        }
    };
    /**
     * @private
     * @param {Event} e Event
     * @return {Array.<import("../Marker").default>} Marker
     */
    // eslint-disable-next-line class-methods-use-this
    Marker.prototype.markerClickOrPopup = function (e, marker) {
        if (!marker) {
            return;
        }
        if (marker.onClick) {
            marker.onClick(marker, LonLat.fromMapboxgl(e.lngLat), e);
        }
        else {
            marker.openPopup();
        }
    };
    /**
     * @private
     * @param {Event} e Event
     * @return {Array.<import("../Marker").default>} Marker
     */
    Marker.prototype.getMarkersFromEvent_ = function (e) {
        var _this = this;
        return e.features.map(function (feature) { return _this.markers_[feature.properties.id]; });
    };
    /**
     * @private
     * @param {Event} e Event
     */
    Marker.prototype.handleClickCluster_ = function (e) {
        var _this = this;
        if (e.features && e.features.length > 0) {
            this.markersInCluster_(e.features[0], function (markers) {
                if (_this.onClusterClick) {
                    _this.onClusterClick(markers, LonLat.fromMapboxgl(e.lngLat), e);
                }
                else {
                    // Default behaviour
                    var cercaliaMap = _this.map_.getCercaliaMap();
                    cercaliaMap.centerToMarkers(markers);
                }
            });
        }
    };
    /**
     * @private
     * @param {Event} e Event
     */
    Marker.prototype.handleDoubleClick_ = function (e) {
        e.preventDefault();
        var markers = this.getMarkersFromEvent_(e);
        markers.forEach(function (marker) {
            if (marker && marker.onDoubleClick) {
                marker.onDoubleClick(marker, LonLat.fromMapboxgl(e.lngLat), e);
            }
        });
    };
    /**
     * @private
     * @param {Event} e Event
     */
    Marker.prototype.handleMouseMove_ = function (e) {
        var _this = this;
        e.preventDefault();
        if (!e.features[0].properties.cluster) {
            var markers = [];
            if (this.cercaliaMap_.getMultipleFeaturesInPixel()) {
                markers = this.getMarkersFromEvent_(e);
            }
            else {
                var markerWithMaxZIndex = this.getMapboxFeatureWithMaxZindex_(this.map_.queryRenderedFeatures(e.point, { layers: this.cercaliaMap_.getLayerManager().getFeaturesLayersIds() }));
                if (markerWithMaxZIndex.layer.type !== 'symbol') {
                    return;
                }
                markers = [this.markers_[markerWithMaxZIndex.properties.id]];
            }
            markers.forEach(function (marker) {
                if (_this.featuresMouseOvered.indexOf(marker) === -1) {
                    _this.featuresMouseOvered.push(marker);
                    _this.clusterMouseOvered_ = null;
                    if (marker && marker.onMouseOver) {
                        marker.onMouseOver(marker, LonLat.fromMapboxgl(e.lngLat), e);
                    }
                }
            });
            // Detect mouseOut markers
            for (var i = this.featuresMouseOvered.length - 1; i >= 0; i -= 1) {
                var marker = this.featuresMouseOvered[i];
                if (marker !== undefined && marker != null) {
                    if (markers.indexOf(marker) === -1) {
                        if (marker && marker.onMouseOut) {
                            marker.onMouseOut(marker, LonLat.fromMapboxgl(e.lngLat), e);
                        }
                        this.featuresMouseOvered.splice(i, 1);
                    }
                }
            }
        }
        else if (this.onClusterMouseOver) {
            if (!this.clusterMouseOvered_) {
                this.clusterMouseOvered_ = e.features[0];
                this.markersInCluster_(e.features[0], function (markers) {
                    _this.onClusterMouseOver(markers, LonLat.fromMapboxgl(e.lngLat), e);
                });
            }
        }
    };
    /**
     * @private
     */
    Marker.prototype.handleMouseEnter_ = function () {
        this.canvas_.style.cursor = 'pointer';
    };
    /**
     * @private
     * @param {Event} e Event
     */
    Marker.prototype.handleMouseLeave_ = function (e) {
        var _this = this;
        e.preventDefault();
        this.canvas_.style.cursor = '';
        if (this.featuresMouseOvered.length > 0) {
            this.featuresMouseOvered.forEach(function (marker) {
                if (marker && marker.onMouseOut) {
                    marker.onMouseOut(marker, LonLat.fromMapboxgl(e.lngLat), e);
                }
            });
        }
        else if (this.clusterMouseOvered_) {
            if (this.onClusterMouseOut) {
                this.markersInCluster_(this.clusterMouseOvered_, function (markers) {
                    _this.onClusterMouseOut(markers, LonLat.fromMapboxgl(e.lngLat), e);
                });
            }
        }
        this.featuresMouseOvered = [];
        this.clusterMouseOvered_ = null;
    };
    /**
     * @private
     * @param {Event} e Event
     */
    Marker.prototype.handleOnMove_ = function (e) {
        var timeDiff = new Date().getTime() - this.mouseDownTimeStamp_;
        if (e.originalEvent.which === 3 || timeDiff < this.minTimeToDrag || (!isMobile() && this.mouseDownTimeStamp_ === 0)) {
            return;
        }
        if (this.draggingFeatureId_ !== null) {
            this.canvas_.style.cursor = 'grabbing';
            var marker = this.getMarkerById(this.draggingFeatureId_);
            marker.setPosition(e.lngLat);
            if (marker && marker.onDragMove) {
                marker.onDragMove(marker, LonLat.fromMapboxgl(e.lngLat), e);
            }
        }
    };
    /**
     * @private
     * @param {Event} e Event
     */
    Marker.prototype.handleOnUp_ = function (e) {
        var timeDiff = new Date().getTime() - this.mouseDownTimeStamp_;
        this.mouseDownTimeStamp_ = 0;
        if (e.originalEvent.which === 3) {
            return;
        }
        if (timeDiff < this.minTimeToDrag) {
            this.canvas_.style.cursor = 'pointer';
            this.map_.off('mousemove', this.handleOnMove_.bind(this));
            this.map_.off('touchmove', this.handleOnMove_.bind(this));
            this.draggingFeatureId_ = null;
            return;
        }
        this.canvas_.style.cursor = '';
        this.map_.off('mousemove', this.handleOnMove_.bind(this));
        this.map_.off('touchmove', this.handleOnMove_.bind(this));
        var marker = this.getMarkerById(this.draggingFeatureId_);
        if (marker) {
            if (marker.onDragEnd) {
                var markerOldPosition = marker.getPosition();
                if (markerOldPosition.getLat() === e.lngLat.lat && markerOldPosition.getLon() === e.lngLat.lng) {
                    // If the positions are equal it means that has dragged, if are different it means that has been a fast click
                    marker.onDragEnd(marker, LonLat.fromMapboxgl(e.lngLat), e);
                }
                else {
                    this.canvas_.style.cursor = 'pointer';
                }
            }
            if (marker.onDrop) {
                marker.onDropFunction_();
            }
        }
        this.draggingFeatureId_ = null;
    };
    /**
     * @private
     * @param {Event} e Event
     */
    Marker.prototype.handleMouseDown_ = function (e) {
        var _this = this;
        e.preventDefault();
        if (e.originalEvent.which === 3) {
            var markers = this.getMarkersFromEvent_(e);
            markers.forEach(function (marker) {
                if (marker && marker.onRightClick) {
                    marker.onRightClick(marker, LonLat.fromMapboxgl(e.lngLat), e);
                }
            });
        }
        else { // Only one draggable feature
            this.mouseDownTimeStamp_ = new Date().getTime();
            var markerWithMaxZIndex = this.getMapboxFeatureWithMaxZindex_(this.cercaliaMap_.getMultipleFeaturesInPixel()
                ? e.features
                : this.map_.queryRenderedFeatures(e.point, { layers: this.cercaliaMap_.getLayerManager().getFeaturesLayersIds() }));
            if (markerWithMaxZIndex.layer.type !== 'symbol' || !markerWithMaxZIndex.properties.draggable) {
                return;
            }
            this.draggingFeatureId_ = markerWithMaxZIndex.properties.id;
            this.canvas_.style.cursor = 'grab';
            this.map_.on('mousemove', this.handleOnMove_.bind(this));
            this.map_.once('mouseup', this.handleOnUp_.bind(this));
            var marker_1 = this.getMarkerById(this.draggingFeatureId_);
            if (marker_1 && marker_1.onDragStart) {
                var timestamp_1 = this.mouseDownTimeStamp_;
                setTimeout(function () {
                    if (_this.draggingFeatureId_ === null || timestamp_1 !== _this.mouseDownTimeStamp_) {
                        return;
                    }
                    marker_1.onDragStart(marker_1, LonLat.fromMapboxgl(e.lngLat), e);
                }, this.minTimeToDrag + 1);
            }
        }
    };
    /**
     * @private
    */
    // eslint-disable-next-line class-methods-use-this
    Marker.prototype.getMapboxFeatureWithMaxZindex_ = function (features) {
        return features.reduce(function (prev, current) { return (prev.properties.zIndex >= current.properties.zIndex ? prev : current); });
    };
    /**
     * @private
     * @param {Event} e Event
     */
    Marker.prototype.handleTouchStart_ = function (e) {
        if (e.points.length !== 1) {
            return;
        }
        e.preventDefault();
        if (e.originalEvent.which === 3) {
            var markers = this.getMarkersFromEvent_(e);
            markers.forEach(function (marker) {
                if (marker && marker.onRightClick) {
                    marker.onRightClick(marker, LonLat.fromMapboxgl(e.lngLat), e);
                }
            });
        }
        else { // Only one draggable feature
            var markerWithMaxZIndex = this.getMapboxFeatureWithMaxZindex_(this.cercaliaMap_.getMultipleFeaturesInPixel()
                ? e.features
                : this.map_.queryRenderedFeatures(e.point, { layers: this.cercaliaMap_.getLayerManager().getFeaturesLayersIds() }));
            if (markerWithMaxZIndex.layer.type !== 'symbol' || !markerWithMaxZIndex.properties.draggable) {
                return;
            }
            this.draggingFeatureId_ = markerWithMaxZIndex.properties.id;
            this.canvas_.style.cursor = 'grab';
            this.map_.on('touchmove', this.handleOnMove_.bind(this));
            this.map_.once('touchend', this.handleOnUp_.bind(this));
            var marker = this.getMarkerById(this.draggingFeatureId_);
            if (marker && marker.onDragStart) {
                marker.onDragStart(marker, LonLat.fromMapboxgl(e.lngLat), e);
            }
        }
    };
    /**
     * @return {Array.<import("../Marker").default>}
     */
    Marker.prototype.getMarkers = function () {
        return Object.entries(this.markers_).map(function (entry) { return entry[1]; });
    };
    /**
     * @param {string} id Id.
     * @return {import("../Marker").default} Marker.
     */
    Marker.prototype.getMarkerById = function (id) {
        return this.markers_[id];
    };
    /**
     * @return {Bounds} Markers
     */
    Marker.prototype.getMarkersBounds = function () {
        var bounds = new Bounds();
        Object.entries(this.markers_).forEach(function (_a) {
            var marker = _a[1];
            bounds.extend(marker.getPosition());
        });
        return bounds;
    };
    /**
     * @param {import("../Marker").default} marker Marker
     */
    Marker.prototype.addMarker = function (marker) {
        var _this = this;
        var id = marker.getId();
        if (this.markers_[id] === undefined) {
            this.markers_[id] = marker;
            marker.setLayer(this);
            var geojson = marker.getGeoJSON();
            this.geojson_.features.push(geojson);
            this.loadImageIfNeeded_(marker, function () { return _this.refreshGeoJSON(Timeout.AddMarker); });
        }
        else {
            throw new Error("Marker with id=".concat(id, " already exists"));
        }
    };
    /**
     * @param {import("../Marker").default} marker
     */
    Marker.prototype.removeMarker = function (marker) {
        this.removeMarkerInner_(marker);
        this.refreshGeoJSON();
    };
    /**
     * @param {Array.<import("../Marker").default>} markers
     */
    Marker.prototype.removeMarkers = function (markers) {
        var _this = this;
        markers.forEach(function (marker) { return _this.removeMarkerInner_(marker); });
        this.refreshGeoJSON();
    };
    /**
     * @private
     * @param {import("../Marker").default} marker Marker
     */
    Marker.prototype.removeMarkerInner_ = function (marker) {
        var id = marker.getId();
        marker.setLayer(null);
        marker.setMap(null);
        this.removeFeatureGeoJSON(id);
        delete this.markers_[id];
    };
    /**
     * Remove all markers
     */
    Marker.prototype.removeAllMarkers = function () {
        var _this = this;
        Object.entries(this.markers_).forEach(function (_a) {
            var marker = _a[1];
            return _this.removeMarkerInner_(marker);
        });
        this.markers_ = {};
        this.refreshGeoJSON();
    };
    /**
     * Remove marker by id
     * @param {string} id Id.
     */
    Marker.prototype.removeMarkerById = function (id) {
        var marker = this.markers_[id];
        if (marker) {
            this.removeMarkerInner_(marker);
            this.refreshGeoJSON(Timeout.RemoveMarker);
        }
        else {
            console.warn("Marker ".concat(id, " not found")); // eslint-disable-line no-console
        }
    };
    /**
     * Load image if it is not loaded.
     * @private
     * @param {Marker} marker Marker
     * @param {Function} callbackFn Callback functoin
     */
    Marker.prototype.loadImageIfNeeded_ = function (marker, callbackFn) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var icon, src, svg, name, loadedImage, width_1, height_1, size, image_1, bitmap;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        icon = marker.getIcon();
                        if (icon.getLoadedIconImage())
                            return [2 /*return*/];
                        src = icon.getSrc();
                        svg = icon.getSVG();
                        name = icon.getFilename();
                        if (!!this.cercaliaMap_.iconsLoaded[src]) return [3 /*break*/, 4];
                        this.cercaliaMap_.iconsLoaded[src] = { src: src, name: name, bitmap: null };
                        if (!!svg) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadImageFromUrl_(src)];
                    case 1:
                        loadedImage = _c.sent();
                        if (loadedImage) {
                            width_1 = loadedImage.width, height_1 = loadedImage.height;
                            Object.keys(this.markers_)
                                .map(function (key) { return _this.cercaliaMap_.getMarkerById(key); })
                                .filter(function (layerMarker) { return layerMarker && layerMarker.getIcon().getSrc() === src; }).forEach(function (layerMarker) {
                                layerMarker.getIcon().setWidth(width_1 !== null && width_1 !== void 0 ? width_1 : 0);
                                layerMarker.getIcon().setHeight(height_1 !== null && height_1 !== void 0 ? height_1 : 0);
                            });
                        }
                        callbackFn();
                        return [3 /*break*/, 3];
                    case 2:
                        size = icon.getSize();
                        image_1 = new Image(size[0], size[1]);
                        image_1.onload = function () {
                            _this.cercaliaMap_.iconsLoaded[src].bitmap = image_1;
                            _this.map_.addImage(src, image_1);
                            callbackFn();
                        };
                        image_1.src = icon.getSrc();
                        _c.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        if (!svg) {
                            bitmap = this.cercaliaMap_.iconsLoaded[src].bitmap;
                            if (bitmap) {
                                icon.setWidth((_a = bitmap.width) !== null && _a !== void 0 ? _a : 0);
                                icon.setHeight((_b = bitmap.height) !== null && _b !== void 0 ? _b : 0);
                            }
                        }
                        callbackFn();
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @private
     * @param {string} urlSrc URL src
     * @return {Promise}
     */
    Marker.prototype.loadImageFromUrl_ = function (urlSrc) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.map_.loadImage(urlSrc, function (error, image) {
                if (error) {
                    reject(error);
                }
                if (!_this.map_.hasImage(urlSrc)) {
                    _this.cercaliaMap_.iconsLoaded[urlSrc].bitmap = image;
                    _this.map_.addImage(urlSrc, image);
                    resolve(image);
                }
            });
        });
    };
    /**
     * @override
     * @param {Marker} marker Marker
     * @param {GeoJSON} geojson GeoJSON
     */
    Marker.prototype.updateFeatureGeoJSON = function (marker) {
        var _this = this;
        this.loadImageIfNeeded_(marker, function () { return _this.refreshGeoJSON(Timeout.AddMarker); });
        _super.prototype.updateFeatureGeoJSON.call(this, marker);
    };
    /**
     * Clear all markers
     */
    Marker.prototype.clearMarkers = function () {
        var _this = this;
        Object.entries(this.markers_).forEach(function (_a) {
            var id = _a[0];
            _this.removeMarkerById(id);
        });
        this.markers_ = {};
    };
    /**
     * @api
     */
    Marker.prototype.clear = function () {
        this.removeAllMarkers();
    };
    /**
     * On change layer to mapboxgl style or from mapboxgl style. Image will be deleted from map, so we need
     * to call addImage to map again.
     * @override
     * @param {import("../Map").default} map Map
     */
    Marker.prototype.setMap = function (map) {
        var _this = this;
        _super.prototype.setMap.call(this, map);
        Object.entries(this.cercaliaMap_.iconsLoaded).forEach(function (_a) {
            var iconObj = _a[1];
            if (!_this.map_.hasImage(iconObj.src) && iconObj.bitmap) {
                _this.map_.addImage(iconObj.src, iconObj.bitmap);
            }
        });
    };
    /**
     * @api
     * @param {boolean} visible Visible
     */
    Marker.prototype.toggleLayers = function (visible) {
        var _this = this;
        var layersId = Object.entries(this.layerIds_).map(function (entry) { return entry[1]; });
        layersId.forEach(function (layerId) {
            var layer = _this.map_.getLayer(layerId);
            if (layer) {
                _this.map_.setLayoutProperty(layerId, 'visibility', visible ? 'visible' : 'none');
            }
        });
    };
    /**
     * Converts layer into heatmap. There are two layers: Zone layer for heat, and points layer. Points layers is useful to show markers in the nearest zooms.
     * Read MapboxGL documentation to styling both layers: https://docs.mapbox.com/mapbox-gl-js/style-spec/layers/#heatmap.
     * @param {StyleHeat} styleZones Zones styles.
     * @param {StyleHeat} stylePoints Points styles.
     * @api
     */
    Marker.prototype.enableHeatmap = function (stylePoints, styleZones) {
        if (stylePoints === void 0) { stylePoints = DefaultHeatStylesPoints; }
        if (styleZones === void 0) { styleZones = DefaultHeatStylesZones; }
        this.disableClustering();
        if (!this.heatEnabled_) {
            this.toggleLayers(false);
            this.addLayer(__assign({ id: this.layerHeatIds_.heat, source: this.layerIds_.source, type: 'heatmap' }, styleZones));
            this.addLayer(__assign({ id: this.layerHeatIds_.point, source: this.layerIds_.source, type: 'circle' }, stylePoints));
            this.heatEnabled_ = true;
        }
    };
    /**
     * @api
     */
    Marker.prototype.disableHeatmap = function () {
        this.toggleLayers(true);
        if (this.heatEnabled_) {
            this.removeLayer(this.layerHeatIds_.heat);
            this.removeLayer(this.layerHeatIds_.point);
            this.heatEnabled_ = false;
        }
    };
    /**
   * Get Overlapped markers
   * @param {boolean|undefined} currentExtentView If `true` returns only visible markers at the moment, if not `null` or `false` it returns all markers
   * @param {number=} opt_tolerance Tolerance in meters.
   * @return {Array.<Array.<ol.Feature>>} Array of group (array) of features.
   * @api
     */
    Marker.prototype.getOverlappedMarkers = function (currentExtentView, tolerance) {
        var _this = this;
        if (tolerance === void 0) { tolerance = 5; }
        var toleranceInKm = tolerance / 1000;
        var features;
        if (currentExtentView) {
            features = this.getVisibleMarkers();
        }
        else {
            features = this.geojson_.features;
        }
        features.sort(function (a, b) { return a.properties.id.localeCompare(b.properties.id); });
        var dbscanResults = clustersDbscan(featureCollection(features), toleranceInKm, { minPoints: 2 });
        var dbscanResultsInsideCluster = dbscanResults.features.filter(function (f) { return f.properties.cluster !== undefined; });
        var clusterMap = new Map();
        dbscanResultsInsideCluster.forEach(function (f) {
            var clusterId = f.properties.cluster;
            if (!clusterMap.has(clusterId)) {
                clusterMap.set(clusterId, [f]);
            }
            else {
                clusterMap.get(clusterId).push(f);
            }
        });
        var groupedMarkers = Array.from(clusterMap.values());
        var currentLayer = this.cercaliaMap_.getLayerById("".concat(this.id_));
        var groupedMarkersCercalia = groupedMarkers.map(function (group) {
            var markers = group.map(function (f) {
                var marker = _this.cercaliaMap_.getMarkerById(f.properties.id, currentLayer);
                return marker;
            });
            return markers;
        });
        return groupedMarkersCercalia;
    };
    /**
     * Return visible markers in current map view
     * @returns {Array.<import("../Marker").default>} Markers
     */
    Marker.prototype.getVisibleMarkers = function () {
        var bounds = this.map_.getBounds();
        var sw = bounds.getSouthWest();
        var ne = bounds.getNorthEast();
        var turfBboxPolygon = bboxPolygon([sw.lng, sw.lat, ne.lng, ne.lat]);
        return this.geojson_.features.filter(function (feature) { return feature.properties.visible && booleanPointInPolygon(feature, turfBboxPolygon); });
    };
    /**
     * Overlap markers if some markers coincides in the same exact coordinate.
     * This function must be called after add or remove markers.
     * @api
     * @param {number} [separation] Separation from anchor. Default `3`.
     */
    Marker.prototype.separateOverlapMarkers = function (separation) {
        if (separation === void 0) { separation = 3; }
        var positionHash = this.getMarkersSamePosition_();
        Object.entries(positionHash).forEach(function (_a) {
            var markers = _a[1];
            if (markers.length > 1) {
                var fraction_1 = 360 / markers.length;
                markers.forEach(function (marker, i) {
                    var icon = marker.getIcon();
                    icon.setRotation(fraction_1 * i);
                    icon.setOffset([0, separation]);
                });
            }
        });
    };
    /**
     * Get markers overlaped on same position
     * @private
     * @return {Object.<string, Array.<import("../Marker").default>>} Markers overlaped with coordinates as key
     */
    Marker.prototype.getMarkersSamePosition_ = function () {
        var positionHash = {};
        Object.entries(this.markers_).forEach(function (_a) {
            var marker = _a[1];
            var posStr = marker.getPosition().toString();
            if (!positionHash[posStr]) {
                positionHash[posStr] = [marker];
            }
            else {
                positionHash[posStr].push(marker);
            }
        });
        return positionHash;
    };
    /**
     * @api
     * @return {number} Layer opacity factor
    */
    Marker.prototype.getLayerOpacityFactor = function () {
        return this.layerOpacityFactor_;
    };
    /**
     * @api
     * @param {number} factor Layer opacity factor
    */
    Marker.prototype.setLayerOpacityFactor = function (factor) {
        this.layerOpacityFactor_ = factor;
        this.refreshGeoJSON();
        if (this.clusteringEnabled_) {
            this.map_.setPaintProperty(this.layerIds_.cluster, 'circle-opacity', ['*', ClusterStyles.OPACITY, this.layerOpacityFactor_]);
            this.map_.setPaintProperty(this.layerIds_.cluster, 'circle-stroke-opacity', ['*', ClusterStyles.STROKE_OPACITY, this.layerOpacityFactor_]);
            this.map_.setPaintProperty(this.layerIds_.clusterText, 'text-opacity', this.layerOpacityFactor_);
        }
        else {
            this.map_.setPaintProperty(this.layerIds_.symbol, 'icon-opacity', ['*', ['get', 'iconOpacity'], this.layerOpacityFactor_]);
            this.map_.setPaintProperty(this.layerIds_.symbol, 'text-opacity', ['*', ['get', 'textOpacity'], this.layerOpacityFactor_]);
        }
    };
    /**
     * @api
     * @return {number} Return min time to start dragging in milliseconds
    */
    Marker.prototype.getMinTimeToDrag = function () {
        return this.minTimeToDrag;
    };
    /**
     * @api
     * @param {number} minTimeToDrag Min time to start dragging in milliseconds
    */
    Marker.prototype.setMinTimeToDrag = function (minTimeToDrag) {
        this.minTimeToDrag = minTimeToDrag;
    };
    return Marker;
}(BaseLayer));
export default Marker;
//# sourceMappingURL=Marker.js.map